const ComplianceSection = () => {
  const badges = [
    { icon: 'ri-file-list-3-line', label: 'AS/NZS 3000' },
    { icon: 'ri-shield-check-line', label: 'EC Licensed' },
    { icon: 'ri-shield-star-line', label: 'Fully Insured' },
    { icon: 'ri-award-line', label: 'WorkSafe Approved' },
  ];

  return (
    <section className="bg-navy py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Compliant with Australian Standards</h2>
          <p className="text-gray-300 text-lg max-w-3xl mx-auto">
            All work performed by NS Electrical WA meets or exceeds Australian Standards requirements, ensuring safety, reliability, and legal compliance for your commercial property.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="bg-white rounded-lg p-8 flex flex-col items-center justify-center border-2 border-gold hover:scale-105 transition-transform"
            >
              <i className={`${badge.icon} text-gold text-5xl mb-4 w-12 h-12 flex items-center justify-center`}></i>
              <span className="text-navy font-bold text-center">{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ComplianceSection;